// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";
import { toFormBody } from "./utils";

/** 添加用户 添加一个新用户，并指定其角色 POST /user/addUser */
export async function addUser(
  body: API.AddUserModel,
  options?: { [key: string]: any }
) {
  return request<API.ResultAddOrUpdate>("/user/addUser", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: toFormBody(body),
    ...(options || {}),
  });
}

/** 查询当前用户信息 查询当前用户信息 GET /user/curUser */
export async function curUser(options?: { [key: string]: any }) {
  return request<API.ResultUserInfo>("/user/curUser", {
    method: "GET",
    ...(options || {}),
  });
}

/** 删除用户 通过用户 ID 删除指定用户 POST /user/delUser */
export async function delUser(
  body: {
    ids: string;
  },
  options?: { [key: string]: any }
) {
  return request<API.ResultDel>("/user/delUser", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: toFormBody(body),
    ...(options || {}),
  });
}

/** 查询用户详情 查询用户信息 POST /user/getUser */
export async function getUser(
  body: API.GetUserModel,
  options?: { [key: string]: any }
) {
  return request<API.ResultUser>("/user/getUser", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: toFormBody(body),
    ...(options || {}),
  });
}

/** 更新用户信息 通过用户 ID 更新指定用户信息 POST /user/updateUser */
export async function updateUser(
  body: API.UpdateUserModel,
  options?: { [key: string]: any }
) {
  return request<API.ResultAddOrUpdate>("/user/updateUser", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: toFormBody(body),
    ...(options || {}),
  });
}
